import { ensureEmailSignaturePreferenceIsPresent } from 'mini-bx-user-custom-properties';
import { extractEmailSignaturePreference } from './extractEmailSignaturePreference';
import { storeEmailSignaturePreferenceItemIdInCache } from 'mini-mail-signature';
import type { EmailSignaturePreference } from '../schema/EmailSignaturePreference';

/**
 * This utility populates the initial Email Signature preferences to UI cache
 */
export const fetchUserEmailSignaturePreference = async (): Promise<EmailSignaturePreference> => {
    const emailSignaturePreferenceResponse = await ensureEmailSignaturePreferenceIsPresent();
    let emailSignaturePreference: EmailSignaturePreference;

    if (emailSignaturePreferenceResponse) {
        // save the SDS itemID in local cache for future use when it needs to be updated
        storeEmailSignaturePreferenceItemIdInCache(emailSignaturePreferenceResponse.Id);

        emailSignaturePreference = extractEmailSignaturePreference(
            emailSignaturePreferenceResponse
        );
    }

    return emailSignaturePreference;
};
